import { isFieldError } from "../utils";
import S from "./styled";

const Textarea = ({
	name,
	label,
	reqd,
	autocomplete = name,
	update,
	errors,
	visible = true,
	brand = "",
}) => {
	return (
		<S.Container className={visible ? `` : `invisible`} data-brand={brand}>
			<label htmlFor={name}>
				{`${label}`} {reqd ? <span className="error">*</span> : null}
			</label>
			<textarea
				name={name}
				id={name}
				autoComplete={autocomplete}
				onChange={(e) => update(name, e.target.value)}
				className={isFieldError(errors, name) ? `error` : ``}
			/>
		</S.Container>
	);
};
export default Textarea;
